// Homepage Google title / description (what the homepage used before it was editable).
const SEO_DEFAULTS = {
  "en": {
    "metaTitle": "Security Company Toronto, Montreal, Ottawa & Quebec",
    "metaDescription": "Vision Security — trusted security company in Montreal, Toronto, Ottawa & Quebec City. Licensed security guards, mobile patrol, event security and surveillance. Get a free quote today."
  },
  "fr": {
    "metaTitle": "Agence de sécurité Montréal, Toronto & Ottawa",
    "metaDescription": "Vision Sécurité protège les entreprises et propriétés au Québec et en Ontario. Agents BSP, contrôle d'accès, prévention des pertes et intervention d'urgence — couverture complète de Montréal à Toronto. Soumission gratuite."
  }
};

export default SEO_DEFAULTS;
